import { useEffect, useState } from "react"
import { autorun, computed, reaction } from "mobx"
import { observer } from "mobx-react"
import { Typography } from "antd"

type Props = {
  expTime: string
  preFetch: () => void
}
export const ConvertFormTimer = observer(({ expTime, preFetch }: Props) => {
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>()

  const exp = computed(() => {
    return Math.floor(
      (new Date(expTime as string).getTime() - new Date().getTime()) / 1000,
    )
  }).get()

  const [delay, setDelay] = useState(exp)

  const startTimer = () => {
    stopTimer()

    const id = setInterval(() => {
      setDelay((delay) => delay - 1)
    }, 1000)

    setIntervalId(id)

    return id
  }

  const stopTimer = () => {
    if (intervalId) {
      clearInterval(intervalId)
    }
  }

  useEffect(() => {
    return () => stopTimer()
  }, [])

  useEffect(() => {
    startTimer()

    setDelay(exp)
  }, [expTime])

  useEffect(() => {
    if (delay === 3) {
      preFetch()
    }

    if (delay <= 0) {
      stopTimer()
    }
  }, [delay])

  return (
    <Typography.Text style={{ color: "#FAAD14" }}>
      {delay > 9 ? delay : `0${delay}`}s
    </Typography.Text>
  )
})
